import React from 'react';

// @import components
import SimpleBoxLoader from 'app_components/commons/loaderSkeletons/simpleBoxLoader';
// import HorizontalCardImageLoader from 'app_components/commons/loaderSkeletons/horizontalCardImageLoader';
// @end

const RoleSkeleton = () => {
  return (
    <React.Fragment>
      <div className='row'>
        <div className='col-lg-12 mb-4'>
          <SimpleBoxLoader width='50%' height='1rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-2 offset-10 mb-4">
          <SimpleBoxLoader width='95%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-12 mb-3">
          <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-12 mb-3">
          <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-12 mb-3">
          <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-12 mb-3">
          <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
        <div className="col-md-12 mb-3">
          <SimpleBoxLoader width='100%' height='2rem' animationSpeed={1} borderRadius='0.25rem' />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RoleSkeleton;
